export default __webpack_public_path__ + "static/media/logo512x512-apple-touch.4cc0a9fc.png";